import type { CallHistoryItem } from '../../types';

const CALL_ORIGIN_MANUAL = 'manual';
const CALL_TYPE_SIP = 'sip';

/**
 * Returns whether an outbound-self interaction should auto-accept SIP on mount.
 *
 * Auto-accept is reserved for direct SIP outbound calls created by the user.
 * Agent and Reverse IVR flows must wait for explicit accept/reject actions.
 */
export function isSipOutboundSelfCall(call: CallHistoryItem): boolean {
  const origin = String(call.origin || '').trim().toLowerCase();
  if (origin !== CALL_ORIGIN_MANUAL) {
    return false;
  }
  const callType = String(call.callType || '').trim().toLowerCase();
  return callType === CALL_TYPE_SIP;
}
